export default (function () {
  return null;
});


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/react-instantsearch/es/src/components/Configure.js
// module id = ../../node_modules/react-instantsearch/es/src/components/Configure.js
// module chunks = 6